import type { Translations } from '../../types'

const setupMessages: Translations = {
  'setup.entry.badge': 'Operazioni Emporion',
  'setup.entry.title': 'Attiva la piattaforma in sicurezza',
  'setup.entry.subtitle':
    'Esegui il bootstrap di prima attivazione per inizializzare accesso amministratore e baseline operativa.',
  'setup.entry.highlights.securityTitle': 'Bootstrap security-first',
  'setup.entry.highlights.securityBody': 'Crea l’account owner admin e blocca correttamente l’accesso iniziale piattaforma.',
  'setup.entry.highlights.operationsTitle': 'Handoff operativo pronto',
  'setup.entry.highlights.operationsBody':
    'Dopo attivazione, continua con readiness checks per pagamenti, email e recovery.',
  'setup.entry.actions.beginSetup': 'Inizia setup',

  'setup.badges.wizard': 'Attivazione piattaforma',
  'setup.progress.mobile': 'Step {{current}} di {{total}}',

  'setup.hero.title': 'Attiva la tua piattaforma commerce',
  'setup.hero.subtitle': 'Un first-boot breve che mette in sicurezza l’accesso admin e prepara l’onboarding operativo.',

  'setup.steps.administrator.title': 'Amministratore',
  'setup.steps.administrator.description': 'Account principale',
  'setup.steps.storeIdentity.title': 'Identità store',
  'setup.steps.storeIdentity.description': 'Profilo storefront iniziale',
  'setup.steps.preferences.title': 'Preferenze operative',
  'setup.steps.preferences.description': 'Guida onboarding',
  'setup.steps.completion.title': 'Review & activate',
  'setup.steps.completion.description': 'Finalizza attivazione piattaforma',

  'setup.administrator.title': 'Crea account amministratore',
  'setup.administrator.subtitle': 'Questo account sarà usato per l’accesso owner-level.',
  'setup.administrator.passwordSectionTitle': 'Policy password di sicurezza',
  'setup.administrator.passwordSectionSubtitle':
    'La piattaforma genera automaticamente chiavi interne e credenziali di sicurezza. Tu definisci solo le credenziali admin.',

  'setup.storeIdentity.title': 'Imposta identità iniziale store',
  'setup.storeIdentity.subtitle':
    'Questi campi vengono persistiti come baseline operativa di bootstrap.',

  'setup.email.providerLabel': 'Provider',

  'setup.email.providers.gmail.title': 'Gmail SMTP',
  'setup.email.providers.gmail.description': 'Relay gestito da Google con onboarding rapido.',
  'setup.email.providers.outlook.title': 'Outlook / Microsoft 365',
  'setup.email.providers.outlook.description': 'SMTP gestito Microsoft per flussi email business.',
  'setup.email.providers.custom.title': 'SMTP personalizzato',
  'setup.email.providers.custom.description': 'Usa credenziali e routing SMTP proprietari.',
  'setup.preferences.title': 'Preferenze operative',
  'setup.preferences.subtitle':
    'Configura provider reali per pagamenti, email e protezione bot. Le credenziali vengono validate e persistite.',
  'setup.preferences.hint':
    'Dopo il primo login, i controlli readiness ti guidano nel completamento operativo selezionato.',
  'setup.optional.paymentsLabel': 'Pagamenti',
  'setup.optional.captchaLabel': 'Protezione bot',

  'setup.optional.payment.stripe': 'Stripe',
  'setup.optional.payment.stripeHint': 'Infrastruttura pagamenti pronta per i flussi checkout.',
  'setup.optional.payment.bankTransfer': 'Bonifico bancario',
  'setup.optional.payment.bankTransferHint': 'Abilita settlement manuale e istruzioni di bonifico.',
  'setup.optional.payment.configureLater': 'Configura dopo',
  'setup.optional.payment.configureLaterHint': 'Attiva piattaforma senza setup pagamenti ora.',

  'setup.optional.captcha.turnstile': 'Cloudflare Turnstile',
  'setup.optional.captcha.turnstileHint': 'Protezione bot a basso attrito per i flussi auth.',
  'setup.optional.captcha.recaptcha': 'Google reCAPTCHA',
  'setup.optional.captcha.recaptchaHint': 'Provider captcha alternativo.',
  'setup.optional.captcha.configureLater': 'Configura dopo',
  'setup.optional.captcha.configureLaterHint': 'Abilita captcha dopo il go-live.',

  'setup.completion.title': 'Review e attivazione',
  'setup.completion.subtitle': 'L’attivazione finalizza il bootstrap sicuro e apre l’area admin.',
  'setup.completion.workspaceTitle': 'Workspace',
  'setup.completion.administratorTitle': 'Amministratore',
  'setup.completion.emailTitle': 'Infrastruttura email',
  'setup.completion.integrationsTitle': 'Integrazioni',
  'setup.completion.readinessTitle': 'Controlli readiness',
  'setup.completion.readinessSecurity': 'Chiavi interne e identificativi recovery generati automaticamente.',
  'setup.completion.readinessAccess': 'Accesso setup pubblico disattivato automaticamente dopo attivazione.',
  'setup.completion.readinessEmail': 'Infrastruttura email pronta per autenticazione e recovery.',
  'setup.completion.readinessOperationalFlow':
    'L’onboarding operativo continua nella dashboard con i controlli readiness.',
  'setup.completion.recoveryTitle': 'Recovery kit',
  'setup.completion.recoveryBody':
    'L’export del recovery bundle è disponibile dopo attivazione nelle impostazioni Security, non durante onboarding.',
  'setup.completion.activatingStatus': 'Attivazione piattaforma…',
  'setup.completion.validationTitle': 'Validazione operativa',
  'setup.completion.validationRun': 'Esegui validazione',
  'setup.completion.validationRunning': 'Validazione in corso…',
  'setup.completion.validationHint': 'Esegui una validazione prima dell’attivazione per verificare provider e credenziali.',
  'setup.completion.notConfigured': 'Non configurato',

  'setup.fields.fullName': 'Nome completo',
  'setup.fields.email': 'Email',
  'setup.fields.storeName': 'Nome store',
  'setup.fields.primaryDomain': 'Dominio principale',
  'setup.fields.timezone': 'Timezone',
  'setup.fields.currency': 'Valuta',
  'setup.fields.passwordLabel': 'Password',
  'setup.fields.confirmPassword': 'Conferma password',

  'setup.placeholders.storeName': 'Emporion Store',
  'setup.placeholders.primaryDomain': 'shop.example.com',
  'setup.placeholders.fullName': 'Mario Rossi',
  'setup.placeholders.ownerEmail': 'owner@azienda.it',

  'setup.password.strengthLabel': 'Robustezza password',
  'setup.password.weak': 'Debole',
  'setup.password.good': 'Buona',
  'setup.password.strong': 'Forte',
  'setup.password.rule.minLength': 'Almeno 8 caratteri',
  'setup.password.rule.uppercase': 'Una lettera maiuscola',
  'setup.password.rule.lowercase': 'Una lettera minuscola',
  'setup.password.rule.number': 'Un numero',
  'setup.password.rule.special': 'Un carattere speciale',
  'setup.password.rule.match': 'Le password coincidono',

  'setup.actions.back': 'Indietro',
  'setup.actions.next': 'Continua',
  'setup.actions.configuring': 'Attivazione piattaforma…',
  'setup.actions.complete': 'Attiva piattaforma',
  'setup.actions.edit': 'Modifica',

  'setup.success.title': 'Piattaforma attivata',
  'setup.success.body':
    'Bootstrap completato. Prosegui con onboarding operativo dal pannello readiness della dashboard admin.',
  'setup.success.next.smtp': 'Valida la consegna SMTP e risolvi eventuali warning.',
  'setup.success.next.payments': 'Abilita e testa almeno un provider di pagamento.',
  'setup.success.next.backup': 'Conferma workflow backup e timestamp di verifica recente.',
  'setup.success.next.goLive': 'Completa checklist go-live prima di aprire traffico storefront.',
  'setup.success.cta': 'Vai al login',

  'setup.validation.title': 'Verifica richiesta',

  'setup.errors.ownerFullName': 'Il nome completo owner è obbligatorio.',
  'setup.errors.ownerEmail': 'L’email owner è obbligatoria.',
  'setup.errors.ownerEmailInvalid': 'Il formato email owner non è valido.',
  'setup.errors.ownerPasswordMismatch': 'Le password non coincidono.',
  'setup.errors.ownerPasswordPolicy':
    'La password deve includere maiuscola, minuscola, numero e carattere speciale.',
  'setup.errors.storeName': 'Il nome store è obbligatorio.',
  'setup.errors.primaryDomain': 'Il dominio principale è obbligatorio.',
  'setup.errors.primaryDomainInvalid': 'Il formato del dominio principale non è valido.',
  'setup.errors.timezone': 'La timezone è obbligatoria.',
  'setup.errors.currency': 'La valuta è obbligatoria.',
  'setup.errors.authorizationKey': 'L’autorizzazione recovery non è valida o mancante.',
  'setup.errors.setupUnavailable': 'Il setup non è disponibile al momento. Contatta il responsabile piattaforma.',
  'setup.errors.stripePublishableKey': 'Inserisci Stripe publishable key.',
  'setup.errors.stripeSecretKey': 'Inserisci Stripe secret key.',
  'setup.errors.stripeWebhookSecret': 'Inserisci Stripe webhook secret.',
  'setup.errors.bankTransferBeneficiary': 'Inserisci beneficiario bonifico.',
  'setup.errors.bankTransferIban': 'Inserisci IBAN bonifico.',
  'setup.errors.bankTransferBicSwift': 'Inserisci BIC/SWIFT bonifico.',
  'setup.errors.bankTransferBankName': 'Inserisci nome banca.',
  'setup.errors.smtpHost': 'Inserisci SMTP host.',
  'setup.errors.smtpUsername': 'Inserisci SMTP username.',
  'setup.errors.smtpPassword': 'Inserisci SMTP password.',
  'setup.errors.smtpFromName': 'Inserisci nome mittente SMTP.',
  'setup.errors.smtpFromEmail': 'Inserisci email mittente SMTP.',
  'setup.errors.smtpFromEmailInvalid': 'Email mittente SMTP non valida.',
  'setup.errors.turnstileSiteKey': 'Inserisci Turnstile site key.',
  'setup.errors.turnstileSecretKey': 'Inserisci Turnstile secret key.',
  'setup.errors.recaptchaSiteKey': 'Inserisci reCAPTCHA site key.',
  'setup.errors.recaptchaSecretKey': 'Inserisci reCAPTCHA secret key.',

  'setup.email.providers.configureLater.title': 'Configura dopo',
  'setup.email.providers.configureLater.description': 'Attiva la piattaforma e configura SMTP dopo il login.',

  'setup.summary.emailProvider.gmail': 'Preferenza email: Gmail SMTP',
  'setup.summary.emailProvider.outlook': 'Preferenza email: Outlook / Microsoft 365 SMTP',
  'setup.summary.emailProvider.custom_smtp': 'Preferenza email: SMTP personalizzato',
  'setup.summary.emailProvider.configure_later': 'Preferenza email: Configura dopo',
  'setup.summary.paymentStrategy.stripe': 'Preferenza pagamenti: Stripe',
  'setup.summary.paymentStrategy.bank_transfer': 'Preferenza pagamenti: Bonifico bancario',
  'setup.summary.paymentStrategy.configure_later': 'Preferenza pagamenti: Configura dopo',
  'setup.summary.botProtection.turnstile': 'Preferenza protezione bot: Cloudflare Turnstile',
  'setup.summary.botProtection.recaptcha': 'Preferenza protezione bot: Google reCAPTCHA',
  'setup.summary.botProtection.configure_later': 'Preferenza protezione bot: Configura dopo',

  'setup.toast.statusError': 'Impossibile leggere stato setup ({{status}}).',
  'setup.toast.statusLoadError': 'Impossibile leggere stato setup.',
  'setup.toast.completed': 'Piattaforma attivata.',
  'setup.toast.completeError': 'Impossibile completare setup.',
  'setup.toast.validationOk': 'Validazione completata: configurazione pronta.',
  'setup.toast.validationWarning': 'Validazione completata con warning.',
  'setup.toast.validationError': 'Validazione fallita: correggi i campi richiesti.',
}

export default setupMessages
